module.exports = __webpack_public_path__ + "img/TechWheelbarrow2_ua.f0c90936.webp";